var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("tool-bar", { attrs: { title: "Search Service Logs" } }),
      _vm._v(" "),
      _c(
        "v-container",
        {
          class: { "pa-0 mt-0": !_vm.isDesktop, "margin-top": _vm.isDesktop },
          attrs: { "grid-list-md": "" }
        },
        [
          _c(
            "v-card",
            {
              class: {
                "mb-5 pb-5": _vm.isMobile,
                "full-height px-4": !_vm.isDesktop,
                "pa-4": _vm.isDesktop
              }
            },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    {
                      staticClass: "py-0",
                      attrs: { xs12: "", sm6: "", md4: "" }
                    },
                    [
                      _c(
                        "v-combobox",
                        {
                          attrs: {
                            label: "Find Provider",
                            items: _vm.providerSearchArray,
                            clearable: true,
                            "error-messages": _vm.providerSearchError,
                            "return-object": true,
                            "search-input": _vm.providerSearchInput,
                            "item-text": "userId",
                            loading: _vm.providerSearchLoading,
                            "no-filter": true
                          },
                          on: {
                            "update:searchInput": function($event) {
                              _vm.providerSearchInput = $event
                            },
                            "update:search-input": function($event) {
                              _vm.providerSearchInput = $event
                            },
                            focus: _vm.clearProviderAutoComplete
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "item",
                              fn: function(ref) {
                                var item = ref.item
                                var tile = ref.tile
                                return [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item.firstName) +
                                      " " +
                                      _vm._s(item.lastName) +
                                      "\n              "
                                  ),
                                  _vm._v(" "),
                                  item.credentialName
                                    ? _c("span", [
                                        _vm._v(
                                          "/" + _vm._s(item.credentialName)
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            },
                            {
                              key: "selection",
                              fn: function(ref) {
                                var item = ref.item
                                var selected = ref.selected
                                return [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item.firstName) +
                                      " " +
                                      _vm._s(item.lastName) +
                                      "\n              "
                                  ),
                                  _vm._v(" "),
                                  item.credentialName
                                    ? _c("span", [
                                        _vm._v(
                                          "/" + _vm._s(item.credentialName)
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.providerSearchModel,
                            callback: function($$v) {
                              _vm.providerSearchModel = $$v
                            },
                            expression: "providerSearchModel"
                          }
                        },
                        [
                          _vm._v(" "),
                          _vm._v(" "),
                          _c(
                            "template",
                            { slot: "no-data" },
                            [
                              _c(
                                "v-list",
                                [
                                  !_vm.providerSearchInput
                                    ? _c("v-list-tile", [
                                        _vm._v(
                                          "\n                  Please type a Provider.\n                "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.providerSearchInput &&
                                  !_vm.providerSearchLoading
                                    ? _c(
                                        "v-list-tile",
                                        { staticClass: "red--text" },
                                        [
                                          _vm._v(
                                            "\n                  No Results\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "py-0",
                      attrs: { xs12: "", sm6: "", md4: "" }
                    },
                    [
                      _c(
                        "v-combobox",
                        {
                          attrs: {
                            label: "Find Student",
                            items: _vm.studentSearchArray,
                            clearable: true,
                            "error-messages": _vm.studentSearchError,
                            "return-object": true,
                            "search-input": _vm.studentSearchInput,
                            "item-text": "studentName",
                            "item-value": "studentName",
                            loading: _vm.studentSearchLoading,
                            "no-filter": true
                          },
                          on: {
                            "update:searchInput": function($event) {
                              _vm.studentSearchInput = $event
                            },
                            "update:search-input": function($event) {
                              _vm.studentSearchInput = $event
                            },
                            focus: _vm.clearStudentAutoComplete
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "item",
                              fn: function(ref) {
                                var item = ref.item
                                var tile = ref.tile
                                return [
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(item.firstName) +
                                            " " +
                                            _vm._s(item.lastName) +
                                            "\n                  "
                                        ),
                                        _c("span", { staticClass: "pl-1" }, [
                                          _vm._v(_vm._s(item.studentExtId))
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("v-list-tile-sub-title", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(item.schoolName) +
                                            "\n                  "
                                        ),
                                        _c("span", { staticClass: "pl-1" }, [
                                          _vm._v("Grade: " + _vm._s(item.grade))
                                        ])
                                      ])
                                    ],
                                    1
                                  )
                                ]
                              }
                            },
                            {
                              key: "selection",
                              fn: function(ref) {
                                var item = ref.item
                                var selected = ref.selected
                                return [
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(item.firstName) +
                                            " " +
                                            _vm._s(item.lastName) +
                                            "\n                "
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.studentSearchModel,
                            callback: function($$v) {
                              _vm.studentSearchModel = $$v
                            },
                            expression: "studentSearchModel"
                          }
                        },
                        [
                          _vm._v(" "),
                          _vm._v(" "),
                          _c(
                            "template",
                            { slot: "no-data" },
                            [
                              _c(
                                "v-list",
                                [
                                  !_vm.studentSearchInput
                                    ? _c("v-list-tile", [
                                        _vm._v(
                                          "\n                  Please type a Student.\n                "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.studentSearchInput &&
                                  !_vm.studentSearchLoading
                                    ? _c(
                                        "v-list-tile",
                                        { staticClass: "red--text" },
                                        [
                                          _vm._v(
                                            "\n                  No Results\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "py-0",
                      attrs: { xs12: "", sm4: "", md4: "" }
                    },
                    [
                      _c(
                        "v-combobox",
                        {
                          attrs: {
                            label: "Service Location",
                            items: _vm.locationSearchArray,
                            clearable: true,
                            "error-messages": _vm.locationSearchError,
                            "item-text": "locationName",
                            "return-object": true,
                            "search-input": _vm.locationSearchInput,
                            loading: _vm.locationSearchLoading,
                            "no-filter": true
                          },
                          on: {
                            "update:searchInput": function($event) {
                              _vm.locationSearchInput = $event
                            },
                            "update:search-input": function($event) {
                              _vm.locationSearchInput = $event
                            },
                            focus: _vm.clearLocationAutoComplete
                          },
                          model: {
                            value: _vm.locationSearchModel,
                            callback: function($$v) {
                              _vm.locationSearchModel = $$v
                            },
                            expression: "locationSearchModel"
                          }
                        },
                        [
                          _c(
                            "template",
                            { slot: "no-data" },
                            [
                              _c(
                                "v-list",
                                [
                                  !_vm.locationSearchInput
                                    ? _c("v-list-tile", [
                                        _vm._v(
                                          "\n                  Please type a Service Location.\n                "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.locationSearchInput &&
                                  !_vm.locationSearchLoading
                                    ? _c(
                                        "v-list-tile",
                                        { staticClass: "red--text" },
                                        [
                                          _vm._v(
                                            "\n                  No Results\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "py-0",
                      attrs: { xs6: "", sm4: "", md4: "" }
                    },
                    [
                      _c(
                        "v-menu",
                        {
                          ref: "serviceMenuStart",
                          attrs: {
                            "close-on-content-click": true,
                            "nudge-right": 40,
                            "return-value": _vm.serviceDateStart,
                            lazy: "",
                            transition: "scale-transition",
                            "offset-y": "",
                            "full-width": "",
                            "max-width": "290px",
                            "min-width": "290px"
                          },
                          on: {
                            "update:returnValue": function($event) {
                              _vm.serviceDateStart = $event
                            },
                            "update:return-value": function($event) {
                              _vm.serviceDateStart = $event
                            }
                          },
                          model: {
                            value: _vm.serviceMenuStart,
                            callback: function($$v) {
                              _vm.serviceMenuStart = $$v
                            },
                            expression: "serviceMenuStart"
                          }
                        },
                        [
                          _vm.isMobile
                            ? _c("v-text-field", {
                                attrs: {
                                  slot: "activator",
                                  clearable: true,
                                  label: "Start Date",
                                  readonly: ""
                                },
                                slot: "activator",
                                model: {
                                  value: _vm.dateStart,
                                  callback: function($$v) {
                                    _vm.dateStart = $$v
                                  },
                                  expression: "dateStart"
                                }
                              })
                            : _c("v-text-field", {
                                attrs: {
                                  slot: "activator",
                                  label: "Start Date",
                                  clearable: true,
                                  "prepend-icon": "event",
                                  readonly: ""
                                },
                                slot: "activator",
                                model: {
                                  value: _vm.dateStart,
                                  callback: function($$v) {
                                    _vm.dateStart = $$v
                                  },
                                  expression: "dateStart"
                                }
                              }),
                          _vm._v(" "),
                          _c("v-date-picker", {
                            attrs: { "no-title": "", scrollable: "" },
                            on: {
                              change: function($event) {
                                return _vm.serviceDateStartChanged(
                                  _vm.serviceDateStart
                                )
                              },
                              input: function($event) {
                                return _vm.$refs.serviceMenuStart.save(
                                  _vm.serviceDateStart
                                )
                              }
                            },
                            model: {
                              value: _vm.serviceDateStart,
                              callback: function($$v) {
                                _vm.serviceDateStart = $$v
                              },
                              expression: "serviceDateStart"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "py-0",
                      attrs: { xs6: "", sm4: "", md4: "" }
                    },
                    [
                      _c(
                        "v-menu",
                        {
                          ref: "serviceMenuEnd",
                          attrs: {
                            "close-on-content-click": true,
                            "nudge-right": 40,
                            "return-value": _vm.serviceDateEnd,
                            lazy: "",
                            transition: "scale-transition",
                            "offset-y": "",
                            "full-width": "",
                            "max-width": "290px",
                            "min-width": "290px"
                          },
                          on: {
                            "update:returnValue": function($event) {
                              _vm.serviceDateEnd = $event
                            },
                            "update:return-value": function($event) {
                              _vm.serviceDateEnd = $event
                            }
                          },
                          model: {
                            value: _vm.serviceMenuEnd,
                            callback: function($$v) {
                              _vm.serviceMenuEnd = $$v
                            },
                            expression: "serviceMenuEnd"
                          }
                        },
                        [
                          _vm.isMobile
                            ? _c("v-text-field", {
                                attrs: {
                                  slot: "activator",
                                  clearable: true,
                                  label: "End Date",
                                  readonly: ""
                                },
                                slot: "activator",
                                model: {
                                  value: _vm.dateEnd,
                                  callback: function($$v) {
                                    _vm.dateEnd = $$v
                                  },
                                  expression: "dateEnd"
                                }
                              })
                            : _c("v-text-field", {
                                attrs: {
                                  slot: "activator",
                                  label: "End Date",
                                  clearable: true,
                                  "prepend-icon": "event",
                                  readonly: ""
                                },
                                slot: "activator",
                                model: {
                                  value: _vm.dateEnd,
                                  callback: function($$v) {
                                    _vm.dateEnd = $$v
                                  },
                                  expression: "dateEnd"
                                }
                              }),
                          _vm._v(" "),
                          _c("v-date-picker", {
                            attrs: { "no-title": "", scrollable: "" },
                            on: {
                              change: function($event) {
                                return _vm.serviceEndDateChanged(
                                  _vm.serviceDateEnd
                                )
                              },
                              input: function($event) {
                                return _vm.$refs.serviceMenuEnd.save(
                                  _vm.serviceDateEnd
                                )
                              }
                            },
                            model: {
                              value: _vm.serviceDateEnd,
                              callback: function($$v) {
                                _vm.serviceDateEnd = $$v
                              },
                              expression: "serviceDateEnd"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "py-0",
                      attrs: { xs12: "", sm4: "", md4: "" }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.statusFilterOptions,
                          "item-text": "text",
                          "item-value": "value",
                          label: "Status",
                          clearable: ""
                        },
                        model: {
                          value: _vm.statusFilter,
                          callback: function($$v) {
                            _vm.statusFilter = $$v
                          },
                          expression: "statusFilter"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "py-0",
                      attrs: { xs12: "", sm6: "", md2: "" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { block: "" },
                          on: { click: _vm.onRetrieveLogsClicked }
                        },
                        [_vm._v("\n            Retrieve Logs\n          ")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "py-0",
                      attrs: { xs12: "", sm6: "", md2: "" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { block: "" },
                          on: { click: _vm.clearSearch }
                        },
                        [_vm._v("Clear Parameters")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card",
                    { staticStyle: { width: "100%" }, attrs: { id: "logs" } },
                    [
                      _c(
                        "v-toolbar",
                        { attrs: { color: "primary" } },
                        [
                          _c(
                            "v-toolbar-title",
                            { staticClass: "white--text" },
                            [
                              _vm._v(
                                "\n              Service Logs\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _vm.totalCount && !_vm.showLoading
                            ? _c(
                                "span",
                                { staticClass: "white--text font-italic pr-3" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.totalCount) +
                                      " results\n          "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.serviceLogsArray.length
                            ? _c(
                                "div",
                                { staticStyle: { "background-color": "#eee" } },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.itemsPerPage,
                                          expression: "itemsPerPage"
                                        }
                                      ],
                                      staticStyle: { padding: "5px" },
                                      on: {
                                        change: [
                                          function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.itemsPerPage = $event.target
                                              .multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                          _vm.retrieveLogs
                                        ]
                                      }
                                    },
                                    _vm._l(_vm.itemsPerPageArray, function(
                                      num,
                                      i
                                    ) {
                                      return _c("option", { key: i }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(num) +
                                            "\n                "
                                        )
                                      ])
                                    }),
                                    0
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        {
                          staticClass: "pa-0",
                          class: {
                            "light-gray-bg": !_vm.serviceLogsArray.length
                          },
                          staticStyle: { "min-height": "150px" }
                        },
                        [
                          _vm._l(_vm.serviceLogsArray, function(log, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "pt-2 px-2",
                                class: { "light-gray-bg": index % 2 !== 0 }
                              },
                              [
                                _c("history-repeatable", {
                                  attrs: {
                                    submission: log,
                                    loadData: _vm.serviceLogsArray
                                  },
                                  on: {
                                    "service-log:deleted": _vm.deleteServiceLog
                                  }
                                })
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c(
                                "v-alert",
                                {
                                  attrs: { value: _vm.errorMsg, type: "error" }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.errorMsg) +
                                      "\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "v-footer",
                        { staticStyle: { "background-color": "#d3d3d3" } },
                        [
                          _vm.serviceLogsArray.length
                            ? _c(
                                "v-flex",
                                { staticClass: "text-xs-center" },
                                [
                                  _c("v-pagination", {
                                    attrs: { length: _vm.totalPages },
                                    on: {
                                      next: _vm.retrieveLogs,
                                      previous: _vm.retrieveLogs,
                                      input: _vm.retrieveLogs
                                    },
                                    model: {
                                      value: _vm.pageNumber,
                                      callback: function($$v) {
                                        _vm.pageNumber = $$v
                                      },
                                      expression: "pageNumber"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("bottom-nav")
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.showLoading ? _c("div", [_c("loading-component")], 1) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-79e323ad", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79e323ad","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service-log/search/service-log-search.vue
// module id = null
// module chunks = 